import { apiRequest } from './api';

export type DimensaoFaturamento = 'bairro' | 'plano' | 'dia_vencimento' | 'periodo';
export type GranularidadePeriodo = 'diario' | 'mensal' | 'anual';

export interface FaturamentoFilters {
  dataInicio: string;
  dataFim: string;
  dimensao: DimensaoFaturamento;
  granularidade: GranularidadePeriodo;
  bairro: string;
  planoId: string;
  diaVencimento: string;
  escritorioId?: string;
}

export interface AgrupamentoFaturamento {
  chave: string;
  label: string;
  valor_faturado: number;
  valor_total_emitido: number;
  quantidade_faturas: number;
  quantidade_pagamentos: number;
  plano_id?: number;
  dia_vencimento?: number;
}

export interface FaturaDetalheFaturamento {
  fatura_id: number;
  cliente_nome: string;
  contrato_titulo: string;
  descricao: string;
  valor_pago: number;
  data_pagamento: string;
  data_vencimento: string;
  forma_pagamento: string;
  bairro_inst: string;
  plano_nome: string;
  dia_vencimento: number | null;
  periodo_chave?: string;
}

export interface RelatorioFaturamentoData {
  summary: {
    total_faturado: number;
    total_emitido: number;
    total_faturas: number;
    total_pagamentos: number;
    data_inicio: string;
    data_fim: string;
    dimensao: DimensaoFaturamento;
    granularidade?: GranularidadePeriodo;
  };
  agrupamentos: AgrupamentoFaturamento[];
  registros: FaturaDetalheFaturamento[];
}

export const relatorioFaturamentoService = {
  async getRelatorio(filters: FaturamentoFilters): Promise<RelatorioFaturamentoData> {
    const params: Record<string, string> = {
      data_inicio: filters.dataInicio,
      data_fim: filters.dataFim,
      dimensao: filters.dimensao,
    };

    if (filters.dimensao === 'periodo') {
      params.granularidade = filters.granularidade;
    }
    if (filters.bairro.trim()) params.bairro = filters.bairro.trim();
    if (filters.planoId) params.plano_id = filters.planoId;
    if (filters.diaVencimento) params.dia_vencimento = filters.diaVencimento;
    if (filters.escritorioId) params.escritorio_id = filters.escritorioId;

    const response = await apiRequest.get<RelatorioFaturamentoData>('/relatorios/faturamento', { params });
    return response.data!;
  },
};
